import { useEffect, useRef } from "react";
import { useSession } from "~/lib/auth-client";
import { client } from "~/lib/orpc-client";

const HUMAN_REVIEW_KEY = "alchema.humanReviewPreference";
const BACKFILLED_KEY = "alchema.humanReviewPreference.backfilled";

export function useHumanReviewBackfill() {
  const { data: session, isPending } = useSession();
  const attemptedRef = useRef(false);

  useEffect(() => {
    if (attemptedRef.current || isPending || !session?.user) return;
    if (typeof window === "undefined") return;

    attemptedRef.current = true;

    void (async () => {
      let legacyValue: string | null;
      try {
        if (window.localStorage.getItem(BACKFILLED_KEY)) return;
        legacyValue = window.localStorage.getItem(HUMAN_REVIEW_KEY);
        if (legacyValue === null) {
          window.localStorage.setItem(BACKFILLED_KEY, "true");
          return;
        }
      } catch {
        return;
      }

      try {
        const serverValue = await client.humanReview.get();
        if (serverValue.updatedAt !== null) {
          try {
            window.localStorage.setItem(BACKFILLED_KEY, "true");
          } catch {
            // Ignore marker storage failures; the backfill can retry later.
          }
          return;
        }

        await client.humanReview.set({
          preference: legacyValue === "true",
          source: "candidate_notice",
        });

        try {
          window.localStorage.setItem(BACKFILLED_KEY, "true");
        } catch {
          // Ignore marker storage failures; the protected server write already succeeded.
        }
      } catch {
        // Network/auth failures remain silent and unmarked so a later session can retry.
      }
    })();
  }, [isPending, session?.user]);
}
